// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, ProductDto } from "@insite/client-framework/Types/ApiModels";

const bargainbinUrl = "/api/v1/bargainbin";

export interface BargainProductsApiParameter extends ApiParameter {
    productId: string;
    bargainBinCategory?: string;
    isBargainBinPage?: boolean; // if its BargainBinPage, we need to call getProductApi after getting products
}

export interface BargainCategoriesApiParameter extends ApiParameter {
    bargainBinCategory: string;
}

export interface BargainBinProductsModel extends BaseModel {
    discountedProducts?: Array<any>;
}

export interface BargainBinsCategoryModel extends BaseModel {
    categoryId: string;
    categoryName: string;
    products: ProductDto[];
    subCategories: BargainBinsCategoryModel[];
}
export interface BargainBinCategoriesModel extends BaseModel {
    bargainBinCategories: BargainBinsCategoryModel[];
}

export const getBargainBinProducts = async (
    parameters: BargainProductsApiParameter,
): Promise<ServiceResult<BargainBinProductsModel>> => {
    try {
        const result = await get<BargainBinProductsModel>(`${bargainbinUrl}/getproducts`, parameters);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const getBargainBinCategories = async (
    parameters: BargainCategoriesApiParameter,
): Promise<ServiceResult<BargainBinCategoriesModel>> => {
    try {
        const result = await get<BargainBinCategoriesModel>(`${bargainbinUrl}/getcategories`, parameters);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};